import React from "react";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";

import './Navbar.css';

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Adiciona a rolagem suave
        });
    };

    return (
        <div className="col-sm-12 footer">
            <Navbar bg="dark" variant="dark">
                <Container>
                <div className="icon-text d-none d-md-block">

                    <Navbar.Brand href="/">
                        <FaIcons.FaRegBookmark className="icon" />
                        Base de Conhecimento Gigabyte Telecom
                    </Navbar.Brand>
                </div>
                    <Button className="btn btn-dark" onClick={scrollToTop}>
                        Topo <AiIcons.AiOutlineVerticalAlignTop />
                    </Button>
                </Container>
            </Navbar>
        </div>
    )
}
export default Footer;